import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ESupportTicketSource } from "../../aiTickets.types";
import { TranscriptMessage } from "./transcript.types";

interface RawMessage {
  id: string;
  sender: "customer" | "ai" | "admin";
  text: string | null;
  messageType?: string | null;
  mediaUrl?: string | null;
  createdAt: string;
}

// in-app returns { data, meta }; whatsapp returns { data, count, page, take }.
// Both message rows expose the same `sender` / `text` / `createdAt` fields and
// are ordered newest-first by the backend.
interface RawListResponse {
  data: RawMessage[];
}

const ROUTE_BY_SOURCE: Record<ESupportTicketSource, string> = {
  [ESupportTicketSource.WhatsApp]: "admin/whatsapp-bot/conversations",
  [ESupportTicketSource.InAppSupport]: "admin/in-app-support/conversations",
};

export const requestTicketTranscript = async ({
  source,
  conversationId,
  take = 50,
}: {
  source: ESupportTicketSource;
  conversationId: string;
  take?: number;
}): Promise<TranscriptMessage[]> => {
  const res: RawListResponse = await instance.get(
    buildUrl(ROUTE_BY_SOURCE[source], conversationId, "messages"),
    { params: { page: 1, take } },
  );

  // newest-first from the API → reverse to chronological for display
  return (res.data ?? [])
    .map((m) => ({
      id: m.id,
      sender: m.sender,
      text: m.text,
      messageType: m.messageType ?? null,
      mediaUrl: m.mediaUrl ?? null,
      createdAt: m.createdAt,
    }))
    .reverse();
};
